import { useAuthStore } from '@/features/auth/auth.store';
import { clearAllSupabaseAuthStorage } from '@/lib/auth-persistence';
import { socketService } from '@/services/socket.service';

/** Clear client auth state after the API rejects our token (expired / invalid). */
export function handleSessionExpired(): void {
  if (useAuthStore.getState().signingOut) return;

  clearAllSupabaseAuthStorage();
  socketService.disconnect();
  useAuthStore.getState().clear();

  if (window.location.pathname !== '/login') {
    window.location.assign('/login');
  }
}
